<template>
  <div class="home-container">
    <v-header></v-header>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapMutations } from "vuex";
import { apiPrefix } from "../../config.js";
import { tool } from "../../common/js/tool.js";
export default {
  data() {
    return {
      value: ""
    };
  },

  computed: {},

  created() {
    console.log(apiPrefix);
    if (!tool.getCookie("token")) {
      this.$router.push({ path: "/login" });
    }
  },

  methods: {},

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import url("../../common/less/variable.less");
</style>
